export default function WetWeatherIcon({ className }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1092_1956)">
        <path
          d="M12 17V16"
          stroke="inherit"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 14V13"
          stroke="inherit"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 14V13"
          stroke="inherit"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 22V23"
          stroke="inherit"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 19V20"
          stroke="inherit"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 19V20"
          stroke="inherit"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.0996 6C11.5996 3.2 13.9996 1 16.9996 1C20.2996 1 22.9996 3.7 22.9996 7C22.9996 8.2 22.5996 9.4 21.9996 10.3"
          stroke="inherit"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 17C2.8 17 1 15.2 1 13C1 10.8 2.8 9 5 9C5.5 9 6 9.1 6.5 9.3C7.3 7.4 9.3 6 11.5 6C13.9 6 16 7.6 16.7 9.7C17.4 9.3 18.1 9 19 9C21.2 9 23 10.8 23 13C23 15.2 21.2 17 19 17"
          stroke="inherit"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1092_1956">
          <rect width="24" height="24" fill="inherit" />
        </clipPath>
      </defs>
    </svg>
  )
}
